import { render } from "./TwoFactorAuthenticationForm.vue?vue&type=template&id=4d5f1f0e"
import script from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationForm.vue?vue&type=script&lang=js"
script.render = render

export default script